export const pulloutIpFromUrl = (url: string): string | null => {
  const result = url.match(/(\d+\.\d+\.\d+\.\d+)(\:\d+)?/)

  if (Array.isArray(result)) {
    return result[1]
  }

  return null
}

export const getHost = (): string => {
  let host = pulloutIpFromUrl(window.location.host)

  if (host === null) {
    const hostParts = window.location.host.split('.')
    host = '.' + hostParts.slice(hostParts.length - 2).join('.')
  }

  return host
}
